module.exports = __webpack_public_path__ + "static/media/profile-pic-chooser-blob.442c064e.svg";